import * as FluentIcon from '@fluentui/react-icons';
import React from 'react';

export type IconSize = 'default' | 'wide';

export interface AppBarIconProps {
    size: IconSize;
}
export const LinkIcon = (
    props: FluentIcon.FluentIconsProps,
): React.ReactElement | null => {
    return FluentIcon.ArrowRight20Filled(props);
};

export const AppsIcon = (
    props: FluentIcon.FluentIconsProps & AppBarIconProps,
): React.ReactElement | null => {
    return props.size === 'default'
        ? FluentIcon.Apps20Regular(props)
        : FluentIcon.Apps24Regular(props);
};

export const AppsIconSelected = (
    props: FluentIcon.FluentIconsProps & AppBarIconProps,
): React.ReactElement | null => {
    return props.size === 'default'
        ? FluentIcon.Apps20Filled(props)
        : FluentIcon.Apps24Filled(props);
};
